export function formatTime(seconds) {
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
}

export function getAssessmentTypeLabel(t, type) {
  const map = {
    'Technical Skills': t('assessment.types.technicalSkills'),
    'Problem Solving': t('assessment.types.problemSolving'),
    Behavioral: t('assessment.types.behavioral'),
  }
  return map[type] || type
}

export function isAnswered(value) {
  if (value === null || value === undefined || value === '') return false
  if (Array.isArray(value) && value.length === 0) return false
  return true
}

export function countAnswered(answers) {
  return Object.keys(answers).filter((k) => isAnswered(answers[k])).length
}

export function detectLang(code) {
  if (!code || code.trim().length === 0) return 'plain text'
  const trimmed = code.trim()

  // 1. SQL & HTML (High confidence signatures)
  if (
    /^\s*(SELECT|INSERT|UPDATE|DELETE|CREATE|DROP|ALTER|WITH)\b/i.test(trimmed)
  )
    return 'sql'
  if (/^\s*<(!DOCTYPE|html|div|span|p|header|footer|section)/i.test(trimmed))
    return 'html'

  // 2. C++: Look for includes and pointers/namespaces
  if (
    /#include\s*<.*>|using\s+namespace\s+\w+|std::\w+|\b(cout|cin)\b/.test(
      trimmed,
    )
  )
    return 'cpp'

  // 3. JAVA: Look for specific keywords and the mandatory "System.out" or "String[] args"
  if (
    /\b(public\s+static\s+void\s+main|System\.out\.print|String\[\]\s+args)\b/.test(
      trimmed,
    )
  )
    return 'java'

  // 4. PHP: Open tag is definitive
  if (/<\?php|namespace\s+.*\\/.test(trimmed)) return 'php'

  // 5. PYTHON: Colons at the end of lines with no curly braces
  if (/\b(def|class)\s+\w+.*:/.test(trimmed) || /:\s*$/m.test(trimmed)) {
    if (!trimmed.includes('{')) return 'python'
  }

  // 6. JAVASCRIPT: Modern syntax fingerprints
  if (/\b(const|let)\s+\w+|=>|console\.log\(|export\s+default/.test(trimmed))
    return 'javascript'

  // 7. C-STYLE FALLBACK (Java vs C++ vs JS)
  // If we see curly braces but haven't triggered the above:
  if (trimmed.includes('{')) {
    // Java often uses 'String' (capitalized) and 'new' with types
    if (/\b(String|ArrayList|HashMap|Integer)\b/.test(trimmed)) return 'java'
    // C++ often uses 'int main()' or 'std::'
    if (/\bint\s+main\s*\(/.test(trimmed)) return 'cpp'
    // Default to JS if it looks like a web script
    return 'javascript'
  }

  return 'plain text'
}
